import { startOfWeek, addWeeks, getISOWeek } from 'date-fns'

const FormatSettings = new Intl.DateTimeFormat('es-BO', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
});

const formatoFecha = (fecha) => {
    let date = new Date(Date.parse(fecha));
    return `${date.getDate()}/${date.toLocaleString('default', { month: 'long' })}/${date.getFullYear()}`;
}
function getNumSemana(fecha) {//fecha -> yyyy-MM-DD
    var parcear = fecha.split('-')
    var fechaHoy = new Date(parseInt(parcear[0]), parseInt(parcear[1]) - 1, parseInt(parcear[2]))
    return getISOWeek(fechaHoy)
}
function getFechaSumadoDias(fecha, dias) {
    var parcear = fecha.split('-')
    var fechaHoy = new Date(parseInt(parcear[0]), parseInt(parcear[1]) - 1, parseInt(parcear[2]))
    fechaHoy.setDate(fechaHoy.getDate() - dias)
    var dia = fechaHoy.getDate();
    dia = dia < 10 ? `0${dia}` : dia
    var mes = fechaHoy.getMonth() + 1;
    mes = mes < 10 ? `0${mes}` : mes
    return `${fechaHoy.getFullYear()}-${mes}-${dia}`
}
function getFechaMenosAnios(fecha, anios) {
    var parcear = fecha.split('-')
    var fechaHoy = new Date(parseInt(parcear[0]), parseInt(parcear[1]) - 1, parseInt(parcear[2]))
    fechaHoy.setFullYear(fechaHoy.getFullYear() + anios)
    var dia = fechaHoy.getDate();
    dia = dia < 10 ? `0${dia}` : dia
    var mes = fechaHoy.getMonth() + 1;
    mes = mes < 10 ? `0${mes}` : mes
    return `${fechaHoy.getFullYear()}-${mes}-${dia}`
}
function getFechHoyFormaroDefault() {
    var date = new Date()
    var dia = date.getDate();
    dia = dia < 10 ? `0${dia}` : dia
    var mes = date.getMonth() + 1;
    mes = mes < 10 ? `0${mes}` : mes
    return `${date.getFullYear()}-${mes}-${dia}`
}
function getFechFuturaFormatoDefault(val) {//true ?YYYY-MM-DD:dia
    var date = new Date();
    date.setDate(date.getDate() + 1);
    var dia = date.getDate();
    dia = dia < 10 ? `0${dia}` : dia
    var mes = date.getMonth() + 1;
    mes = mes < 10 ? `0${mes}` : mes
    if (val == true) {
        return `${date.getFullYear()}-${mes}-${dia}`
    } else {
        return getDiaSemana(date)
    }
}
const formatoFechaSimple = (fecha) => {
    let date = new Date(Date.parse(fecha));
    return `${FormatSettings.format(date)}`;
}
function formatoFechaNumeric(fecha) {//dd/mm/yyyy
    if (fecha == null || fecha == undefined || fecha == '') {
        return ''
    } else {
        let date = new Date(fecha);
        var dia = date.getDate();
        dia = dia < 10 ? `0${dia}` : dia
        var mes = date.getMonth() + 1;
        mes = mes < 10 ? `0${mes}` : mes
        return `${dia}/${mes}/${date.getFullYear()}`;
    }
}
function formatoFechaYMD(fecha) {
    let date = new Date(fecha);
    return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
}
function getDiaSemana(fecha) {
    var dias = ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado']
    return dias[fecha.getDay()]
}
function formatoHora(fecha) {
    var info = new Date(fecha);
    return `${info.getHours()}:${(info.getMinutes() < 10 ? '0' : '') + info.getMinutes()}:${info.getSeconds()}`
}
function formatoHoraSinSegu(fecha) {
    var info = new Date(fecha);
    return `${info.getHours()}:${(info.getMinutes() < 10 ? '0' : '') + info.getMinutes()}`
}
function getSoloHora(fecha) {
    var info = new Date(fecha);
    return `${info.getHours()}`;
}
function formatoFechaCorto(fecha) {
    let date = new Date(Date.parse(fecha));
    return `${date.getDate()}-${date.toLocaleString('es-BO', { month: 'long' })}`;
}
function formatoFechaHoy() {
    var fecha = new Date();
    var returnDateTime = 25569.0 + ((fecha.getTime() - (fecha.getTimezoneOffset() * 60 * 1000)) / (1000 * 60 * 60 * 24));
    var info = returnDateTime.toString().substring(0, 5);
    return info
}
function toIsoString(date) {
    var tzo = -date.getTimezoneOffset(),
        dif = tzo >= 0 ? '+' : '-',
        pad = function (num, digits = 2) {
            return num.toString().padStart(digits, '0');
        };

    return date.getFullYear() +
        '-' + pad(date.getMonth() + 1) +
        '-' + pad(date.getDate()) +
        'T' + pad(date.getHours()) +
        ':' + pad(date.getMinutes()) +
        ':' + pad(date.getSeconds()) +
        '.' + pad(date.getMilliseconds(), 3) +
        dif + pad(Math.floor(Math.abs(tzo) / 60)) +
        ':' + pad(Math.abs(tzo) % 60);
}
function retornarSoloHoraBoliviana(fecha){
    let fechaDate = new Date(fecha);
    const horaBoliviana = fechaDate.toLocaleTimeString('es-BO', {
        timeZone: 'America/La_Paz',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    });
    return horaBoliviana;
}
export default {
    formatoFecha, formatoFechaSimple, formatoHora, formatoFechaCorto, formatoFechaHoy, getDiaSemana,
    getSoloHora, toIsoString, formatoFechaNumeric, formatoFechaYMD, formatoHoraSinSegu, getFechaMenosAnios,
    getFechHoyFormaroDefault, getFechFuturaFormatoDefault, getNumSemana, getFechaSumadoDias, retornarSoloHoraBoliviana
}